// extracted by mini-css-extract-plugin
export default {"containerSection":"Home_containerSection__5TVMx"};